{
    document.querySelectorAll<HTMLFormElement>('form[form-validation]').forEach(form => {

        const validator = useValidator(form);

        const formSuccess = form.querySelector<HTMLDivElement>('[form-success]');
        const formError = form.querySelector<HTMLDivElement>('[form-error]');
        const formControls = form.querySelector<HTMLDivElement>('[form-controls]');

        form.addEventListener('submit', async e => {
            e.preventDefault();

            validator.reset();

            try {
                const response = await fetch(form.action, {
                    method: form.method || "post",
                    body: new FormData(form),
                });

                if (await validator.isValid(response)) {
                    const data = await response.json();
                    if (!data) {
                        throw response;
                    }

                    console.log('form result', data);

                    if (!data.success) {
                        throw data.error;
                    }

                    if (formControls) formControls.style.display = 'none';
                    if (formSuccess) formSuccess.style.display = '';
                }
            } catch (error) {
                if (formError) {
                    formError.innerHTML = formError.innerHTML.replace('{error}', `${error}`);
                    formError.style.display = '';
                }

                console.error(error);
            }
        });
    });


    function useValidator(form: HTMLFormElement) {
        function reset() {
            for (const element of Array.from(form.elements) as (HTMLElement | RadioNodeList)[]) {
                const controls = (element as RadioNodeList).length ? Array.from(element as RadioNodeList) as HTMLElement[] : [element as HTMLElement];
                for (const control of controls) {
                    control.classList.remove('is-invalid');
                    const message = control.parentElement?.querySelector<HTMLElement>('.invalid-feedback');
                    if (message) {
                        message.classList.remove('field-validation-error');
                        message.classList.add('field-validation-valid');
                        message.textContent = '';
                    }
                }
            }
        }

        function showErrors(errors: Record<string, string>) {
            for (const [key, value] of Object.entries(errors)) {
                const element = form.elements.namedItem(key) as HTMLElement | RadioNodeList;
                if (element) {
                    const controls = (element as RadioNodeList).length ? Array.from(element as RadioNodeList) as HTMLElement[] : [element as HTMLElement];
                    for (const control of controls) {
                        control.classList.add('is-invalid');
                        const message = control.parentElement?.querySelector<HTMLElement>('.invalid-feedback');
                        if (message) {
                            message.classList.remove('field-validation-valid');
                            message.classList.add('field-validation-error');
                            message.textContent = value as string;
                        }
                    }
                }
            }
        }

        async function isValid(response: Response) {
            reset();

            if (
                response.status !== 400 ||
                !response.headers.get('content-type')?.includes('application/problem+json')
            ) {
                if (!response.ok) throw response;
                return true;
            }

            const problem = await response.json();
            const errors = problem?.errors || {};

            showErrors(errors);

            return false;
        }

        return {
            reset,
            showErrors,
            isValid,
        }
    }
}